/**
 * VP-261 — wspólne stałe integracji Stripe → tracking (backend + panel w hubie).
 * Signing secret webhooka Stripe: `whsec_` + ciąg alfanumeryczny (Stripe: base62, 32+ znaków;
 * dopuszczamy `_`, żeby nie odrzucać sekretów testowych z CLI).
 */
export const STRIPE_SIGNING_SECRET_RE = /^whsec_[A-Za-z0-9_]{16,}$/;
